import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

const navItems = [
  { label: "首页", to: "/" },
  { label: "电影", to: "/category/movie" },
  { label: "电视剧", to: "/category/tv" },
  { label: "综艺", to: "/category/variety" },
];

export default function Navbar() {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const [keyword, setKeyword] = useState("");

  const handleSearch = (event: React.FormEvent) => {
    event.preventDefault();
    const value = keyword.trim();
    setMenuOpen(false);
    navigate(value ? `/search?q=${encodeURIComponent(value)}` : "/search");
  };

  return (
    <header className="sticky top-0 z-50 w-full border-b border-background-200/70 bg-background-50/90 backdrop-blur">
      <div className="flex h-16 items-center gap-3 px-4 md:px-8">
        <Link to="/" className="flex shrink-0 items-center gap-2">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-accent-500 text-background-50">
            <i className="ri-play-circle-fill text-xl" aria-hidden="true"></i>
          </span>
          <span className="font-heading text-xl font-bold tracking-tight text-foreground-950">
            97<span className="text-accent-500">视频</span>
          </span>
        </Link>

        <nav className="ml-6 hidden items-center gap-1 md:flex">
          {navItems.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              className="cursor-pointer rounded-md px-3 py-2 text-sm font-medium text-foreground-600 transition-colors hover:bg-background-100 hover:text-foreground-950"
            >
              {item.label}
            </Link>
          ))}
          <Link
            to="/search"
            className="cursor-pointer rounded-md px-3 py-2 text-sm font-medium text-foreground-600 transition-colors hover:bg-background-100 hover:text-foreground-950"
          >
            搜索
          </Link>
          <Link
            to="/about"
            className="cursor-pointer rounded-md px-3 py-2 text-sm font-medium text-foreground-600 transition-colors hover:bg-background-100 hover:text-foreground-950"
          >
            关于
          </Link>
        </nav>

        <form
          onSubmit={handleSearch}
          className="ml-auto hidden items-center gap-2 rounded-full border border-background-300/60 bg-background-100 px-3 py-1.5 md:flex"
        >
          <i
            className="ri-search-line text-base text-foreground-500"
            aria-hidden="true"
          ></i>
          <input
            type="text"
            value={keyword}
            onChange={(e) => setKeyword(e.target.value)}
            placeholder="搜索影视、演员、导演"
            className="w-44 bg-transparent text-sm text-foreground-900 placeholder:text-foreground-500 focus:outline-none lg:w-56"
          />
          <button
            type="submit"
            className="cursor-pointer whitespace-nowrap rounded-full bg-primary-500 px-3 py-1 text-xs font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            搜索
          </button>
        </form>

        <button
          type="button"
          onClick={() => setMenuOpen((v) => !v)}
          aria-label="打开菜单"
          className="ml-auto flex h-10 w-10 cursor-pointer items-center justify-center rounded-md text-foreground-800 hover:bg-background-100 md:hidden"
        >
          <i
            className={menuOpen ? "ri-close-line text-2xl" : "ri-menu-line text-2xl"}
            aria-hidden="true"
          ></i>
        </button>
      </div>

      {menuOpen && (
        <div className="border-t border-background-200/70 bg-background-50 px-4 pb-4 pt-3 md:hidden">
          <form
            onSubmit={handleSearch}
            className="mb-3 flex items-center gap-2 rounded-full border border-background-300/60 bg-background-100 px-3 py-2"
          >
            <i
              className="ri-search-line text-base text-foreground-500"
              aria-hidden="true"
            ></i>
            <input
              type="text"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索影视、演员、导演"
              className="w-full bg-transparent text-sm text-foreground-900 placeholder:text-foreground-500 focus:outline-none"
            />
          </form>
          <div className="flex flex-col">
            {[...navItems, { label: "搜索", to: "/search" }, { label: "关于", to: "/about" }].map(
              (item) => (
                <Link
                  key={item.to}
                  to={item.to}
                  onClick={() => setMenuOpen(false)}
                  className="cursor-pointer rounded-md px-3 py-2.5 text-sm font-medium text-foreground-700 hover:bg-background-100 hover:text-foreground-950"
                >
                  {item.label}
                </Link>
              ),
            )}
          </div>
        </div>
      )}
    </header>
  );
}